import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";

export const ScreenTwoContainer = styled(Grid)({
  display: "flex",
  flexFlow: "column",
  width: "800px",

  "& > div": {
    margin: "10px 0 0",
  },
});

export const BookingsContainer = styled(Grid)({
  width: "580px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
});

export const BookingsAmountContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  gap: "5px",
});
